import { makeStyles } from 'tss-react/mui';

export const useTitleStyles = makeStyles()(theme => ({
  titleContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(3),
  },
  title: {
    color: theme.palette.grey[900],
    letterSpacing: '-0.01em',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '22px',
  },
}));
